import { PassFailStandardSettings } from 'apps/studio/components/settings/fields/PassFail/standard'
import { FieldSettingsPanel } from 'apps/studio/components/settings/fields/Base/standard'
import { DesignSettingsPanel } from 'apps/studio/components/settings/fields/Base/design'
import { PassFailChoicesPanel } from 'apps/studio/components/settings/fields/PassFail/choices'
import { PassFailAdvancedPanel } from 'apps/studio/components/settings/fields/PassFail/advanced'

export const PassFailSettings = [
  FieldSettingsPanel(PassFailStandardSettings),
  DesignSettingsPanel,
  PassFailChoicesPanel,
  // ConditionsPanel,
  PassFailAdvancedPanel,
]
